import { FC } from 'react'

import { Modal, ModalProps } from '@mantine/core'
import { ReactComponent as CloseIcon } from 'assets/close.svg'

import { cx } from 'utils/cx'

import s from './s.module.scss'

const CustomModal: FC<ModalProps> = (props) => {
  return (
    <Modal
      {...props}
      classNames={{
        body: cx(s.body, props.classNames?.body),
        close: s.closeButton,
        content: cx(s.inner, props.classNames?.content),
        header: cx(s.header, props.classNames?.header),
        overlay: s.overlay,
        title: cx(s.headerTitle, props.classNames?.title),
      }}
      closeButtonProps={{
        icon: <CloseIcon />,
      }}
    >
      {props.children}
    </Modal>
  )
}

export default CustomModal
